import { useNavigate } from 'react-router-dom';
import Button from '../../components/base/Button';

export default function TermsAndPrivacyPage() {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <Button
            variant="outline"
            onClick={handleGoBack}
            className="flex items-center gap-2"
          >
            <i className="ri-arrow-left-line"></i>
            Voltar
          </Button>
          <h1 className="text-3xl font-bold text-black">
          </h1>
          <div className="w-20"></div> {/* Spacer for centering */}
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-lg p-8 space-y-8">
          <div className="prose prose-gray max-w-none">
            <h1 className="text-3xl font-bold text-black mb-8"></h1>
            
            <h2 className="text-2xl font-bold text-black mb-6 border-b-2 border-black pb-2">
              <strong>Termos de Uso do Aplicativo Magistral</strong>
            </h2>
            
            <div className="space-y-6 text-black leading-relaxed">
              <div>
                <h3 className="text-lg font-semibold text-black mb-3"><strong>1. Aceitação dos Termos</strong></h3>
                <p>
                  Ao baixar, instalar, acessar ou utilizar o aplicativo "Magistral" (doravante denominado "Aplicativo"), você concorda em se submeter a estes Termos de Uso. Caso não concorde com qualquer disposição aqui contida, você não deve utilizar o Aplicativo. A aceitação explícita dos termos será solicitada no primeiro acesso.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-black mb-3"><strong>2. Descrição do Serviço</strong></h3>
                <p>
                  O Magistral é um assistente digital para gestão de tratamentos homeopáticos, permitindo que o usuário organize, monitore e registre a adesão de toda a família a rotinas de medicação. As funcionalidades incluem lembretes de dose, registro de eventos de saúde e um sistema de gamificação para incentivar o bem-estar e o engajamento familiar.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-black mb-3"><strong>3. Aviso Legal: O Aplicativo não é um Serviço Médico</strong></h3>
                <p>
                  O conteúdo e as ferramentas do Aplicativo são oferecidos apenas para fins informativos e de organização pessoal. O Aplicativo <strong>não substitui a orientação, o diagnóstico ou o tratamento fornecido por um profissional de saúde qualificado</strong>, como um médico ou farmacêutico. A empresa <strong>Magistral Homeopatia</strong> não se responsabiliza por quaisquer decisões de saúde que você tome com base no uso do Aplicativo.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-black mb-3"><strong>4. Uso do Aplicativo</strong></h3>
                <p>
                  O uso do Aplicativo é pessoal e não comercial. Você concorda em utilizá-lo apenas para os devidos fins e em conformidade com as leis aplicáveis. É proibido utilizar o Aplicativo para fins ilegais, difamatórios, fraudulentos ou que violem os direitos de terceiros.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-black mb-3"><strong>5. Propriedade Intelectual</strong></h3>
                <p>
                  Todo o conteúdo do Aplicativo, incluindo, mas não se limitando a, o logo da folha, os personagens, as imagens, o código-fonte, o design e os textos, é de propriedade exclusiva da <strong>Magistral Homeopatia</strong> e/ou de seus licenciados. A reprodução, modificação, distribuição ou qualquer uso não autorizado desses materiais é estritamente proibida.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-black mb-3"><strong>6. Limitação de Responsabilidade</strong></h3>
                <p>
                  O uso do Aplicativo é de sua inteira responsabilidade. A <strong>Magistral Homeopatia</strong> não garante a precisão ou a completude das informações fornecidas por você e não se responsabiliza por danos diretos, indiretos, incidentais ou consequenciais, incluindo danos à saúde, que possam surgir do uso ou da incapacidade de uso do Aplicativo.
                </p>
              </div>
            </div>

            <hr className="my-8 border-black" />

            <h2 className="text-2xl font-bold text-black mb-6 border-b-2 border-black pb-2">
              <strong>Política de Privacidade do Aplicativo Magistral</strong>
            </h2>
            
            <div className="space-y-6 text-black leading-relaxed">
              <div>
                <h3 className="text-lg font-semibold text-black mb-3"><strong>1. Introdução e Objetivo</strong></h3>
                <p>
                  Esta Política de Privacidade descreve como os seus dados pessoais e de saúde são coletados, utilizados, armazenados e protegidos no aplicativo "Magistral". Ela integra os Termos de Uso e é aplicável a todos os usuários. Ao utilizar o Aplicativo, você aceita explicitamente as práticas descritas nesta Política. A <strong>Magistral Homeopatia</strong> se compromete a cumprir a Lei Geral de Proteção de Dados (LGPD) e a respeitar seus princípios.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-black mb-3"><strong>2. Dados Coletados</strong></h3>
                <p>Coletamos os seguintes tipos de dados:</p>
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li><strong>Dados de Cadastro:</strong> Nome de usuário e e-mail.</li>
                  <li><strong>Dados Pessoais dos Membros da Família:</strong> Nomes, datas de nascimento e sexo.</li>
                  <li><strong>Dados de Saúde (Sensíveis):</strong> Informações sobre tratamentos, nomes de medicamentos, dosagens, frequência, histórico de doses, registro de sintomas e doenças. Esses dados são inseridos por você.</li>
                  <li><strong>Dados de Uso:</strong> Informações técnicas sobre sua interação com o Aplicativo (telas acessadas, tempo de uso, tipo de dispositivo), coletadas de forma anonimizada para análise e melhoria do serviço.</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-black mb-3"><strong>3. Finalidade do Tratamento de Dados</strong></h3>
                <p>Os dados são coletados exclusivamente para as seguintes finalidades:</p>
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li>Fornecer as funcionalidades do Aplicativo, como lembretes de dose e relatórios de progresso.</li>
                  <li>Melhorar e personalizar a experiência do usuário.</li>
                  <li>Apoiar a gamificação e o monitoramento familiar de saúde.</li>
                  <li>Enviar notificações e comunicações essenciais sobre o uso do Aplicativo.</li>
                  <li><strong>Não vendemos ou comercializamos seus dados de saúde.</strong></li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-black mb-3"><strong>4. Armazenamento e Segurança dos Dados</strong></h3>
                <p>
                  Seus dados são armazenados em servidores seguros localizados em <strong>São Paulo (AWS sa-east-1), Brasil</strong> e operados em infraestrutura confiável da <strong>Amazon Web Services (via Supabase)</strong>. Implementamos medidas de segurança técnicas e organizacionais, como criptografia e controle de acesso, para proteger seus dados contra perda, acesso não autorizado e uso indevido.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-black mb-3"><strong>5. Compartilhamento de Dados</strong></h3>
                <p>
                  Não compartilhamos seus dados de saúde com terceiros sem o seu consentimento explícito, exceto se exigido por lei. Os dados de uso podem ser compartilhados de forma agregada e anonimizada para análise e pesquisa, sem que seja possível identificar você ou sua família.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-black mb-3"><strong>6. Direitos do Usuário (Titular dos Dados)</strong></h3>
                <p>Você tem o direito de solicitar:</p>
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li>Acesso aos seus dados pessoais.</li>
                  <li>Correção de dados incompletos ou desatualizados.</li>
                  <li>Exclusão de seus dados pessoais.</li>
                  <li>Informações sobre o compartilhamento de seus dados.</li>
                </ul>
                <p className="mt-2">
                  Você pode exercer esses direitos entrando em contato pelo e-mail <strong>magistralhomeopatia@gmail.com</strong>.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-black mb-3"><strong>7. Alterações na Política de Privacidade</strong></h3>
                <p>
                  Podemos atualizar esta Política de Privacidade a qualquer momento. Você será notificado sobre as alterações através do Aplicativo ou por e-mail, e a versão atualizada estará sempre disponível em <strong>https://magistralhomeopatia.com.br/terms-and-privacy</strong>.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-black mb-3"><strong>8. Contato</strong></h3>
                <p>
                  Em caso de dúvidas sobre esta Política, entre em contato conosco através do e-mail <strong>magistralhomeopatia@gmail.com</strong>.
                </p>
              </div>
            </div>

            <hr className="my-8 border-black" />

            <div className="bg-white rounded-lg p-6">
              <p className="text-sm text-black italic text-center">
                <em>Documento criado em conformidade com a Lei Geral de Proteção de Dados (LGPD - Lei 13.709/18) e demais legislações aplicáveis.</em>
              </p>
              <p className="text-sm text-black mt-4 text-center">
                Última atualização: {new Date().toLocaleDateString('pt-BR')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}